import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from './shared/service/form-builder.service';
import { FormElement } from './shared/model/form-element.model';
import { FormGroup } from './shared/model/form-group.model';
import { FormTemplate } from './shared/model/form-template.model';
import { FormField } from './shared/model/form-field.model';
import { ValueTypeEnum } from './shared/model/value-type-enum.model';
import { FormElementType } from './shared/model/form-element-type.model';
import { FormElementTypes } from './shared/service/form-element-types.service';
import { AuthService } from '../shared/index';
import {
  UtilService,
  DialogService,
  NotificationService,
  TranslationService,
  NameValueInteger,
  NameValInteger,
  NameDisplayValInteger,
} from '../shared/index';
import { FormElementTextBox } from './shared/model/form-element-textbox.model';
import { FormElementCheckBox } from './shared/model/form-element-checkbox.model';
import { FormElementTextDisplay } from './shared/model/form-element-text-display.model';
import { FormElementHeader } from './shared/model/form-element-header.model';
import { FormElementDropDownStringValue } from './shared/model/form-element-dropdown-string-value.model';
import { FormElementDropDownIntegerValue } from './shared/model/form-element-dropdown-integer-value.model';
import { FormFields } from './shared/service/form-fields.service';
import { FormElementDateInput } from './shared/model/form-element-date-input.model';
import { FormElementIntegerInput } from './shared/model/form-element-integer-input.model';
import { NavigationService } from '../shared/navigation/navigation.service';
import { FormBuilderEditElementComponent } from './form-builder-edit-element/form-builder-edit-element.component';
import { FormWidgetType } from './shared/service/form-widget-type.service';
import { FormFieldGroup } from './shared/model/form-field-group.model';
import { FormElementSummary } from './shared/model/form-element-summary.model';
import { FormElements } from './shared/service/form-elements.service';
import { FormBuilderProfileEditElementComponent } from './form-builder-profile-element/index';
import { FormElementProfile } from './shared/model/profile/form-element-profile.model';
import { FormElementSocialMediaType } from './shared/model/social-media/form-element-social-media-type.model';
import { FormElementSocialMedia } from './shared/model/social-media/form-element-social-media.model';
import { FormElementListing } from './shared/model/listing/form-element-listing.model';
import { FormElementProfileAddress } from './shared/model/profile/address/form-element-profile-address.model';
import { FormBuilderProfileAddressEditElementComponent } from './form-builder-profile-address-element/index';
import { FormElementHbaProfileData } from './shared/model/vertical/hba/form-element-hba-profile-data.model';
import { FormBuilderHbaProfileDataEditElementComponent } from './vertical/form-builder-hba-profile-data-element/index';
import { FormBuilderSettingsComponent } from './form-builder-settings/form-builder-settings.component';
import { FormBuilderSettings } from './shared/model/settings/form-builder-settings.model';
import { RevenueItemService } from '../revenue/shared/revenue-items/revenue-item.service';
import { FieldGroupTypeEnum } from './shared/model/field-group-type-enum.model';
import { NameDescrVal } from '../shared/model/name-descr-val.model';
import { FormBuilderMembershipLevelEditElementComponent } from './form-builder-membership-level-element/index';
import { FormElementMembershipLevel } from './shared/model/membership-level/form-element-membership-level.model';
import { FormFieldRevenueInfo } from './shared/model/revenue/form-field-revenue-info.model';
import { ConfigService } from '../config/shared/config.service';
import { ProfileOrgIndEnum } from './shared/model/settings/profile-org-ind-enum.model';
import { FormElementAffiliationCode } from './shared/model/affiliation-code/form-element-affiliation-code.model';
import { FormBuilderAffiliationChecklistEditElementComponent } from './form-builder-affiliation-checklist-element/index';
import { FormElementAffiliationCodeOption } from './shared/model/affiliation-code/form-element-affiliation-code-option.model';
import { FormBuilderListingEditElementComponent } from './form-builder-listing-element/form-builder-listing-edit-element.component';
import { FormBuilderFileUploadEditElementComponent } from './form-builder-upload-file-element/form-builder-upload-file-edit-element.component';
import { ArcService } from '../revenue/shared/arc/arc.service';
import { ArcSearch, ArcFormula } from '../revenue/shared/arc/index';
import { Dialog } from 'primeng/dialog';
import { MONTHS } from '../config/shared/constants/date-constants';
import { Title } from '@angular/platform-browser';
import { FormBuilderEmailOptIntEditElementComponent } from './form-builder-email-optin-element';
import { FormElementEmailOptIn } from './shared/model/email-optin/form-element-email-optin.model';
import { IFormBuilderProfileDisplayElement } from './shared/model/form-builder-shared.model';

@Component({
  selector: 'wl-form-builder',
  templateUrl: 'form-builder.component.html',
  styleUrls: ['form-builder.component.css'],
  providers: [FormBuilder, UtilService, FormElementTypes, FormFields, NavigationService, FormWidgetType, FormElements, RevenueItemService],
    standalone: false
})
export class FormBuilderComponent implements OnInit {
  private _formBuilder: FormBuilder;
  private _utilService: UtilService;
  private _notifyService: NotificationService;
  private _formElementTypeService: FormElementTypes;
  private _dialogService: DialogService;
  private _formFieldsService: FormFields;
  private _route: ActivatedRoute;
  private _navigationService: NavigationService;
  private _formWidgetTypeService: FormWidgetType;
  private _translationService: TranslationService;
  private _formElementService: FormElements;
  private _formElementIndex: number = -1;
  private _revenueItemService: RevenueItemService;
  private _configService: ConfigService;
  private _authService: AuthService;
  private _arcService: ArcService;

  @ViewChild('editFormElementModal', { static: false }) private _editFormElementModal: FormBuilderEditElementComponent;
  @ViewChild('relatedProfileSettingsElement')
  private _relatedProfileSettingsElement: FormBuilderProfileEditElementComponent;
  @ViewChild('relatedOrgSettingsElement')
  private _relatedOrgSettingsElement: FormBuilderProfileEditElementComponent;
  @ViewChild('realtedProfileDisplayElement', { static: false }) _relatedProfileDisplayElement: IFormBuilderProfileDisplayElement;
  @ViewChild('listingSettingsElement', { static: false }) _listingSettingsElement: FormBuilderListingEditElementComponent;
  @ViewChild('profileAddressSettingsElement', { static: false })
  _profileAddressSettingsElement: FormBuilderProfileAddressEditElementComponent;
  @ViewChild('hbaProfileDataSettingsElement', { static: false })
  _hbaProfileDataSettingsElement: FormBuilderHbaProfileDataEditElementComponent;
  @ViewChild('formSettingsComponent', { static: false }) _formSettingsComponent: FormBuilderSettingsComponent;
  @ViewChild('membershipLevelSettingsElement', { static: false })
  _membershipLevelSettingsElement: FormBuilderMembershipLevelEditElementComponent;
  @ViewChild('affiliationCodeSettingsElement', { static: false })
  _affiliationCodeSettingsElement: FormBuilderAffiliationChecklistEditElementComponent;
  @ViewChild('fileUploadSettingsElement', { static: false }) _fileUploadSettingsElement: FormBuilderFileUploadEditElementComponent;
  @ViewChild('newFormElementModal', { static: false }) _newElementModal: Dialog;
  @ViewChild('emailOptInSettingsElement', { static: false }) _emailOptInSettingsElement: FormBuilderEmailOptIntEditElementComponent;

  public monthItems = MONTHS;
  public formTemplate: FormTemplate;
  public availableFormElementTypes: Array<FormElementType> = new Array<FormElementType>();
  public availableFormFields: Array<FormField> = new Array<FormField>();
  public selectedNewFormElementTypeId: number = 0;
  public selectedFormField: FormField;
  public formId: number = 0;
  public selectedFormElement: FormElement;
  public selectedFormElementOriginalState: FormElement;
  public selectedFormFieldGroup: FormFieldGroup;
  public availableFormFieldGroups: Array<FormFieldGroup> = new Array<FormFieldGroup>();
  public relatedProfileSettings: FormElementProfile;
  public socialMediaSettings: FormElementSocialMedia;
  public listingSettings: FormElementListing;
  public billingAddressSettings: FormElementProfileAddress;
  public mailingAddressSettings: FormElementProfileAddress;
  public hbaProfileDataSettings: FormElementHbaProfileData;
  public formSettings: FormBuilderSettings;
  public availableValues: Array<NameDescrVal>;

  public availableFormWidgetTypes: Array<NameValInteger>;
  public selectedWidgetType: NameValInteger;
  public selectedDisplayText: string;
  public selectedHeaderText: string;
  public selectedSubHeaderText: string;
  public selectedLabelText: string;
  public selectedFieldValue: any;
  public potentialFieldPrice: number;
  public selectedFieldPrice: number;
  public hasArc: boolean;
  public useArc: boolean;
  public availableArcs: Array<ArcFormula>;
  public selectedArc: ArcFormula;
  public enableProration: boolean;
  public selectedProrationMonth = MONTHS[0].value;
  public fieldIsRequired: boolean;
  public tenantHttpsUrl: string;
  public formViewerUrl: string;

  public isLoading: boolean;
  public showNewItemModal = false;
  public showSettingsModal = false;

  public availableFormFieldsRAW: Array<FormField> = new Array<FormField>();

  public constructor(
    formBuilder: FormBuilder,
    utilService: UtilService,
    notifyService: NotificationService,
    formElementTypeService: FormElementTypes,
    dialogService: DialogService,
    formFieldsService: FormFields,
    route: ActivatedRoute,
    navigationService: NavigationService,
    formWidgetTypeService: FormWidgetType,
    translationService: TranslationService,
    formElementService: FormElements,
    authService: AuthService,
    configService: ConfigService,
    revenueItemService: RevenueItemService,
    arcService: ArcService,
    private _title: Title
  ) {
    this.isLoading = true;

    this._formBuilder = formBuilder;
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._formElementTypeService = formElementTypeService;
    this._dialogService = dialogService;
    this._formFieldsService = formFieldsService;
    this._route = route;
    this._navigationService = navigationService;
    this._formWidgetTypeService = formWidgetTypeService;
    this._translationService = translationService;
    this._formElementService = formElementService;
    this._revenueItemService = revenueItemService;
    this._configService = configService;
    this._authService = authService;
    this._arcService = arcService;

    this.selectedFieldValue = null;
    this.potentialFieldPrice = 0;
    this.hasArc = false;
    this.selectedFieldPrice = null;
    this.useArc = false;
    this.availableArcs = [];
    this.selectedArc = new ArcFormula();

    this.availableFormWidgetTypes = new Array<NameValInteger>();
    this.selectedWidgetType = new NameValInteger('', 0);

    this.selectedFormFieldGroup = new FormFieldGroup();
    this.availableFormFieldGroups = new Array<FormFieldGroup>();
    this.availableValues = new Array<NameDescrVal>();

    this.formTemplate = new FormTemplate();
    //ensure there is at least 1 form group
    if (this.formTemplate.FormGroups.length == 0) {
      let formGroup1 = new FormGroup();
      formGroup1.Id = 1;
      formGroup1.Name = 'Form Element Group 1';
      formGroup1.Title = '';
      formGroup1.Order = 1;

      this.formTemplate.FormGroups.push(formGroup1);
    }

    this.selectedFormField = new FormField();
    this.selectedFormElement = new FormElement();
    this.selectedFormElementOriginalState = new FormElement();

    this.selectedDisplayText = '';
    this.selectedHeaderText = '';
    this.selectedSubHeaderText = '';
    this.selectedLabelText = '';
    this.socialMediaSettings = new FormElementSocialMedia();
    this.formSettings = new FormBuilderSettings();
  }
  ngOnInit(): void {
    this.tenantHttpsUrl = this._authService.getTenantHttpsUrl();

    this._route.params.subscribe((params) => {
      if (this._utilService.isNotNullOrUndefined(params['id'])) {
        this.formId = Number(params['id']);

        this._formBuilder.getForm(this.formId).then((data: FormTemplate) => {
          this._title.setTitle(data.Title);
          if (this._utilService.isNullOrUndefined(data)) {
            this._navigationService.navigateToFormBuilderTemplate;
          } else {
            this.formTemplate = data;
            this.formTemplate.Id = this.formId;
            this.formViewerUrl = this.tenantHttpsUrl + '/atlas/forms/' + this.formId;
          }
          this.isLoading = false;
        });
      } else {
        this.formId = 0;

        this._formBuilder.getForm(this.formId).then((data: FormTemplate) => {
          if (this._utilService.isNullOrUndefined(data)) {
            this._navigationService.navigateToFormBuilderTemplate;
          } else {
            this.formTemplate = data;
            this.formTemplate.Id = this.formId;
            this.formViewerUrl = this.tenantHttpsUrl + '/atlas/forms/' + this.formId;
          }
          this.isLoading = false;
        });
        this.isLoading = false;
      }
    });

    this.formTemplate.Name = '';

    this._formWidgetTypeService.getAvailbleWidgetTypes().then((data: Array<NameDisplayValInteger>) => {
      this.availableFormWidgetTypes = data;
      this.selectedWidgetType = data[0];
    });

    this._formElementTypeService.getFormElementTypes().then((data: Array<FormElementType>) => {
      this.availableFormElementTypes = data;
      this.selectedNewFormElementTypeId = 1;
    });

    this._formFieldsService.getFormFieldGroups().then((data: Array<FormFieldGroup>) => {
      this.availableFormFieldGroups = data;

      var blankFormFieldGroup = new FormFieldGroup();
      blankFormFieldGroup.intialize();

      //ensure there is an empty value to start the list
      this._utilService.arrayAddEntryToBeginning(this.availableFormFieldGroups, blankFormFieldGroup);
    });
  }

  public addFormWidget = (): void => {
    let order: number = this.getNextFormElementOrderNumber();

    switch (this.selectedWidgetType.Value) {
      case 1:
        //header
        this.selectedNewFormElementTypeId = 8; //textbox
        break;

      case 2:
        //Text Display
        this.selectedNewFormElementTypeId = 7; //textbox
        break;
      case 3:
        //Database Field
        switch (this.selectedFormField.DisplayValueType) {
          case 1: //string
            this.selectedNewFormElementTypeId = 1; //textbox
            break;
          case 2: //integer
          case 3: // decimal
            this.selectedNewFormElementTypeId = 5; //integer input
            break;
          case 4: //date
            this.selectedNewFormElementTypeId = 6; //date input
            break;
          case 5: //boolean
            this.selectedNewFormElementTypeId = 2; //checkbox
            break;
          case 6: //profile
            if (this.selectedFormField.FieldGroupType === 14) {
              this.selectedNewFormElementTypeId = 19;
            } else {
              this.selectedNewFormElementTypeId = 9; //relatedProfile
            }
            break;
          case 7:
            // social media
            this.selectedNewFormElementTypeId = 10;
            break;
          case 8:
            // listing
            this.selectedNewFormElementTypeId = 11;
            break;
          case 9:
            // string dropdown
            this.selectedNewFormElementTypeId = 1;
            break;
          case 11:
            // profile address
            this.selectedNewFormElementTypeId = 13;
            break;
          case 12:
            // HBA ProfileData
            this.selectedNewFormElementTypeId = 14;
            break;
          case 13:
            // State selector
            this.selectedNewFormElementTypeId = 15;
            break;
          case 14:
            // membership level
            this.selectedNewFormElementTypeId = 16;
            break;
          case 15:
            // affcode checklist
            this.selectedNewFormElementTypeId = 17;
            break;
          case 16:
            //file upload
            this.selectedNewFormElementTypeId = 18;
            break;
          case 20:
            // email opt in
            this.selectedNewFormElementTypeId = 20;
            break;
          default: //textbox
            //default to textbox
            this.selectedNewFormElementTypeId = 1;
            break;
        }
        break;
      default:
        break;
    }

    this._formElementService.getFormElementByElementType(this.selectedNewFormElementTypeId).then((data: any) => {
      let formElement: any;
      let order: number = this.getNextFormElementOrderNumber();

      switch (data.ElementTypeId) {
        case 1:
          var formElementTextBox = new FormElementTextBox();
          formElementTextBox.intialize();
          formElementTextBox.Value = '';
          formElementTextBox.Placeholder = '';
          formElementTextBox.LabelText = this.selectedLabelText;
          formElement = formElementTextBox;
          break;
        case 2:
          var formElementCheckBox = new FormElementCheckBox();
          formElementCheckBox.intialize();
          formElementCheckBox.Value = false;
          formElementCheckBox.LabelText = this.selectedLabelText;
          formElement = formElementCheckBox;
          break;
        case 3:
          var formElementDropDownStringValue = new FormElementDropDownStringValue();
          formElementDropDownStringValue.intialize();
          formElementDropDownStringValue.Value = '';
          formElementDropDownStringValue.LabelText = this.selectedLabelText;
          formElement = formElementDropDownStringValue;
          break;
        case 4:
          var formElementDropDownIntegerValue = new FormElementDropDownIntegerValue();
          formElementDropDownIntegerValue.intialize();
          formElementDropDownIntegerValue.Value = 0;
          formElementDropDownIntegerValue.LabelText = this.selectedLabelText;
          formElement = formElementDropDownIntegerValue;
          break;
        case 5:
          var formElementIntegerInput = new FormElementIntegerInput();
          formElementIntegerInput.intialize();
          formElementIntegerInput.Value = 0;
          formElementIntegerInput.LabelText = this.selectedLabelText;
          formElement = formElementIntegerInput;
          break;
        case 6:
          var formElementDateInput = new FormElementDateInput();
          formElementDateInput.intialize();
          formElementDateInput.Value = new Date();
          formElementDateInput.LabelText = this.selectedLabelText;
          formElement = formElementDateInput;

          break;
        case 7:
          var formElementTextDisplay = new FormElementTextDisplay();
          formElementTextDisplay.intialize();
          formElementTextDisplay.Text = this.selectedDisplayText;
          formElement = formElementTextDisplay;
          break;
        case 8:
          var formElementHeader = new FormElementHeader();
          formElementHeader.intialize();
          formElementHeader.HeaderText = this.selectedHeaderText;
          formElementHeader.SubHeaderText = this.selectedSubHeaderText;
          formElement = formElementHeader;
          break;
        case 9:
          formElement = this._relatedProfileSettingsElement.relatedProfileSettings;
          break;
        case 19:
          formElement = this._relatedOrgSettingsElement.relatedProfileSettings;
          break;
        case 10:
          this.socialMediaSettings.LabelText = this._translationService.getInstantTitlecase('forms.form-builder.social-media');
          formElement = this.socialMediaSettings;
          break;
        case 11:
          formElement = this._utilService.clone(this._listingSettingsElement.listingSettings);
          break;
        case 13:
          formElement = this._profileAddressSettingsElement.profileAddressSettings;
          break;
        case 14:
          formElement = this._hbaProfileDataSettingsElement.hbaProfileDataSettings;
          break;
        case 15:
          formElement = new FormElement();
          formElement.LabelText = this.selectedLabelText;
          formElement.ElementTypeId = 15;
          break;
        case 16:
          formElement = new FormElementMembershipLevel();
          formElement = this._membershipLevelSettingsElement.membershipLevelSettings;
          formElement.LabelText = this._translationService.getInstantTitlecase('forms.form-builder.membership-level');
          break;
        case 17:
          formElement = new FormElementAffiliationCode();
          formElement = this._affiliationCodeSettingsElement.affCodeSettings;
          formElement.LabelText = this.selectedLabelText;
          break;
        case 18:
          formElement = this._fileUploadSettingsElement.fileUploadSettings;
          break;
        case 20:
          formElement = new FormElementEmailOptIn();
          formElement = this._emailOptInSettingsElement.emailOptInData;
          break;
      }

      let addWidget: boolean = true;
      if (this.selectedWidgetType.Value == 3 && this._utilService.isNotNullOrUndefined(this.selectedFormField)) {
        //verify that this field can be added
        //None = 0,
        //OneToOne = 1,
        //OneToMany = 2
        if (this.selectedFormField.PrimaryTableRelationType == 1 || this.selectedFormFieldGroup.FieldGroupType == 4) {
          //can only have 1 of these fields on the form
          //.FieldGroupType == 4 is additional related Profiels..so they have a 1 to many relationship but we only add them to the form once.  The public app handles how to add multiples as all multipels will have the same group of fields to display
          let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
            return this._utilService.isNotNullOrUndefined(el.Field) && el.Field.FieldType == this.selectedFormField.FieldType;
          });
          if (this._utilService.isNotNullOrUndefined(existingFormField)) {
            //field already exists
            if (this.selectedFormField.DisplayValueType == 5) {
              //boolean checkbox
              //set them to be mutually exclusive rather than preventing them from appearing
              existingFormField['IsMutuallyExclusive'] = true;
              formElement['IsMutuallyExclusive'] = true;
            } else {
              addWidget = false;
            }
          }
        }

        if (this.selectedWidgetType.Value == 3) {
          formElement.Field = this._utilService.clone(this.selectedFormField);

          if (formElement.Field.FieldType == 141) {
            formElement.Field.FieldName = 'ProfileCustomFields_CustomFieldID_' + formElement.Field.SecondaryId;
          }

          if (this._utilService.isNotNullOrUndefined(this.selectedFormField.FieldValue)) {
            formElement.Field.FieldValue = this.selectedFormField.FieldValue;

            if (this.hasArc && this.useArc) {
              let revInfos = new Array<FormFieldRevenueInfo>();
              let revInfo = new FormFieldRevenueInfo();
              revInfo.UseArc = this.useArc;
              revInfo.IsProrated = this.enableProration;
              revInfo.ProrationMonth = this.selectedProrationMonth;
              revInfo.RevenueItemNum = this.selectedFormField.FieldValue;
              revInfos.push(revInfo);
              formElement.Field.RevenueInfo = revInfos;
              revInfo.ArcInfo.ArcId = this.selectedArc.ArcID;
              revInfo.ArcInfo.Descr = this.selectedArc.Descr;
            } else if (this.selectedFieldPrice > 0 || this.enableProration) {
              let revInfos = new Array<FormFieldRevenueInfo>();
              let revInfo = new FormFieldRevenueInfo();
              revInfo.IsProrated = this.enableProration;
              revInfo.ProrationMonth = this.selectedProrationMonth;
              revInfo.Price = this.selectedFieldPrice ?? 0;
              revInfo.RevenueItemNum = this.selectedFormField.FieldValue;
              revInfos.push(revInfo);
              formElement.Field.RevenueInfo = revInfos;
            }
          }
        }

        //if (formElement.ElementTypeId == 18) {
        //    let existingFormFields = this.formTemplate.FormGroups[0].GroupElements.filter((x: FormElement) => x.ElementTypeId == 18);
        //    for (let element of existingFormFields as Array<FormElementFile>) {
        //        if (element.WebContentTypeId == formElement.WebContentTypeId)
        //            addWidget = false;
        //    }
        //}
      }

      formElement.ElementTypeId = data.ElementTypeId;
      formElement.Guid = data.Guid;

      formElement.HelpText = '';
      formElement.Order = order;

      if (formElement.ElementTypeId == 9) {
        let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
          return this._utilService.isNotNullOrUndefined(el.ElementTypeId) && el.ElementTypeId == 9;
        });
        if (this._utilService.isNotNullOrUndefined(existingFormField)) {
          addWidget = false;
        } else {
          formElement.LabelText = 'Additional Related Contact';
          formElement.Field.DisplayName = 'Additional Related Contact';
          formElement.ElementTypeId = 9;

          this.relatedProfileSettings = formElement;
        }
      }

      if (formElement.ElementTypeId == 19) {
        let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
          return this._utilService.isNotNullOrUndefined(el.ElementTypeId) && el.ElementTypeId == 19;
        });
        if (this._utilService.isNotNullOrUndefined(existingFormField)) {
          addWidget = false;
        } else {
          formElement.LabelText = 'Additional Related Organization';
          formElement.Field.DisplayName = 'Additional Related Organization';
          formElement.ElementTypeId = 19;

          this.relatedProfileSettings = formElement;
        }
      }

      if (formElement.ElementTypeId == 11) {
        let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
          return this._utilService.isNotNullOrUndefined(el.ElementTypeId) && el.ElementTypeId == 11;
        });
        if (this._utilService.isNotNullOrUndefined(existingFormField)) {
          addWidget = false;
        } else {
          formElement.LabelText = 'Listing';
          formElement.Field.DisplayName = 'Listing';
          formElement.ElementTypeId = 11;

          formElement.Field.RevenueInfo = this._utilService.clone(this._listingSettingsElement.listingSettings.Field.RevenueInfo);
          this.listingSettings = formElement;
          this.fieldIsRequired = formElement.Required;
        }
      }

      if (formElement.ElementTypeId == 13) {
        let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
          return this._utilService.isNotNullOrUndefined(el.ElementTypeId) && el.ElementTypeId == 13;
        });
        if (this._utilService.isNotNullOrUndefined(existingFormField)) {
          if (existingFormField.AddressType == formElement.AddressType) {
            addWidget = false;
          }
        }
        if (addWidget == true) {
          if (formElement.AddressType.BillingDefault == true) {
            formElement.LabelText = 'Billing Address';
            formElement.Field.DisplayName = 'Billing Address';

            formElement.ElementTypeId = 13;
            this.billingAddressSettings = formElement;
          } else if (formElement.AddressType.MailingDefault == true) {
            formElement.LabelText = 'Mailing Address';
            formElement.Field.DisplayName = 'Mailing Address';

            formElement.ElementTypeId = 13;
            this.mailingAddressSettings = formElement;
          }

          this._profileAddressSettingsElement.ngOnInit();
        }
      }

      if (formElement.ElementTypeId == 14) {
        let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
          return this._utilService.isNotNullOrUndefined(el.ElementTypeId) && el.ElementTypeId == 14;
        });
        if (this._utilService.isNotNullOrUndefined(existingFormField)) {
          addWidget = false;
        } else {
          formElement.LabelText = 'HBA Profile Data';
          formElement.Field.DisplayName = 'HBA Profile Data';
          formElement.ElementTypeId = 14;

          this.hbaProfileDataSettings = formElement;
        }
      }

      if (formElement.ElementTypeId == 20) {
        let existingFormField = this.formTemplate.FormGroups[0].GroupElements.find((el: FormElement) => {
          return this._utilService.isNotNullOrUndefined(el.ElementTypeId) && el.ElementTypeId == 20;
        });
        if (this._utilService.isNotNullOrUndefined(existingFormField)) {
          addWidget = false;
        }
      }

      if (formElement.ElementTypeId == 18) {
        formElement.LabelText = this._fileUploadSettingsElement.fileUploadSettings.LabelText;
      }

      formElement.Required = this.fieldIsRequired;

      //formElement.EditMode = true;
      if (addWidget == true) {
        if (this._formElementIndex >= 0) {
          // insert the elements while keeping the order in tact
          formElement.Order = this.formTemplate.FormGroups[0].GroupElements[this._formElementIndex].Order + 1;

          for (let i = this._formElementIndex + 1; i < this.formTemplate.FormGroups[0].GroupElements.length; i++) {
            this.formTemplate.FormGroups[0].GroupElements[i].Order++;
          }
          this.formTemplate.FormGroups[0].GroupElements.splice(this._formElementIndex + 1, 0, formElement);
          this._formElementIndex = -1;
          this.updateFormElementOrder();
        } else {
          this.formTemplate.FormGroups[0].GroupElements.push(formElement);
        }
      }
      this.showNewItemModal = false;

      if (addWidget == false) {
        //display message they can't add field
        let fieldExistsMessage: string = this._translationService.getInstantTitlecase('forms.form-builder.field-already-exists-message');
        this._dialogService.message(fieldExistsMessage);
      }
    });
  };

  public editFormElement = (formElement: any) => {
    formElement.EditMode = true;
    this.updateFormElementAvailableMutualExclusiveControlOptions();
    this._editFormElementModal.open(formElement);
  };

  public removeFormElement = (formElement: FormElementTextBox, formGroup: FormGroup) => {
    var newElements = this._utilService.arrayRemoveEntry(formGroup.GroupElements, formElement);

    formGroup.GroupElements = newElements;
  };

  public save = () => {
    this.cleanUp();
    if (this.formId > 0) {
      this.formTemplate.Id = this.formId;
      this._formBuilder.updateForm(this.formTemplate).then(() => {
        let message: string = this._translationService.getInstantTitlecase('forms.form-builder.save-success-message');
        this._notifyService.success(message);
        //this._navigationService.navigateToFormBuilderTemplate(this.formId);
      });
    } else {
      this._formBuilder.createForm(this.formTemplate).then((data: number) => {
        let message: string = this._translationService.getInstantTitlecase('forms.form-builder.save-success-message');
        this._notifyService.success(message);
        this._navigationService.navigateToFormBuilderTemplate(data);
      });
    }
  };

  // cleanup the model of unnecessary items before storing it
  public cleanUp = () => {
    this.formTemplate.FormGroups[0].GroupElements.forEach((x) => {
      // social media
      if (x.ElementTypeId == 10) {
        x.SocialMediaFields = x.SocialMediaFields.filter((f: FormElementSocialMediaType) => f.Visible);
      }
      // affiliation code checklist
      if (x.ElementTypeId == 17) {
        x.AffCodeOptions = x.AffCodeOptions.filter((f: FormElementAffiliationCodeOption) => f.Visible);
      }
      // Mutually MutuallyExclusive AffCodes
      if (x.ElementTypeId == 2 && x.IsMutuallyExclusive == false) {
        x.MutuallyExclusiveFormElements = [];
      }
    });
  };

  public addItemDropdownListInteger = (formElement: FormElementDropDownIntegerValue): void => {
    //verify the item to be added has a unique value
    if (this._utilService.arrayContainsEntry(formElement.Items, 'value', formElement.ProposedItemValue)) {
      this._dialogService.alert('Warning', 'Items must have unique values');
    } else {
      let item: NameValueInteger = new NameValueInteger(formElement.ProposedItemName, formElement.ProposedItemValue);
      formElement.Items.push(item);

      formElement.ProposedItemName = '';
      formElement.ProposedItemValue = 0;
    }
  };

  public removeItemDropdownListInteger = (formElement: FormElementDropDownIntegerValue): void => {
    let newItems: Array<NameValueInteger> = this._utilService.arrayRemoveEntryByPropertyValue(
      formElement.Items,
      'value',
      formElement.SelectedValue
    );

    formElement.Items = newItems;
  };

  public onSelectedFormWidgetTypeChange = (data: NameValInteger) => {
    this.selectedWidgetType = data;
  };

  public onSelectedFormFieldGroupChange = (formFieldGroup: FormFieldGroup): void => {
    this.selectedFormFieldGroup = formFieldGroup;
    this.selectedLabelText = '';
    this.availableValues = new Array<NameDescrVal>();

    // populate any social media fields necessary
    if (formFieldGroup.FieldGroupType == 7 && !this.socialMediaSettings.SocialMediaFields.length) {
      this._formFieldsService.getActiveSocialMediaTypes().then((data: any) => {
        this.socialMediaSettings.SocialMediaFields = data.Result.map((x: any) => {
          let field = new FormElementSocialMediaType();
          field.SocialMediaTypeId = x.SocialMediaTypeID;
          field.Name = x.Name;
          return field;
        });

        // sort the fields
        this.socialMediaSettings.SocialMediaFields = this.socialMediaSettings.SocialMediaFields.sort((a, b) => {
          if (a.Name > b.Name) return 1;
          if (a.Name < b.Name) return -1;
          return 0;
        });
      });
    }

    this._formFieldsService.getFormFieldsForGroup(this.selectedFormFieldGroup.FieldGroupType).then((data: any) => {
      var blankFormField = new FormField();
      blankFormField.intialize();

      this.availableFormFields = data;
      this.availableFormFieldsRAW = this._utilService.clone(this.availableFormFields);
      //ensure there is an empty value to start the list
      if (data[0].FieldName != '') {
        this._utilService.arrayAddEntryToBeginning(this.availableFormFields, blankFormField);
      }

      //remove either profile org name field or first/last/mi name fields if form setting is for org or ind
      if (this.selectedFormFieldGroup.FieldGroupType == 1) {
        if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_FirstName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_LastName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Mi');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Prefix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Suffix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Title');
        } else {
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_OrgName');
        }
      }

      //do opposite of above for main contact
      if (this.selectedFormFieldGroup.FieldGroupType == 6) {
        if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
          this._utilService.arrayRemoveEntryByPropertyValue(
            this.availableFormFields,
            'FieldName',
            'RelatedProfile_MainContact_Contact_OrgName'
          );
        } else {
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_FirstName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_LastName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Mi');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Prefix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Suffix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Title');
        }
      }

      if (!this.canSelectField(formFieldGroup.FieldGroupType)) this.selectedFormField = this.availableFormFields[1];
      else this.selectedFormField = this.availableFormFields[0];

      if (formFieldGroup.FieldGroupType == FieldGroupTypeEnum.MembershipFields) {
        this._membershipLevelSettingsElement.refetchMembershipLevels();
      }
    });
  };

  public onSelectedFormFieldChange = (formField: FormField): void => {
    this.selectedFormField = formField;
    this.selectedLabelText = formField.DisplayName;
    this.selectedFieldPrice = null;
    this.hasArc = false;
    this.useArc = false;
    this.availableArcs = [];
    this.selectedArc = new ArcFormula();
    if ([FieldGroupTypeEnum.AdditionalInfoFields, FieldGroupTypeEnum.PurchaseItemFields].some((x) => x == formField.FieldGroupType)) {
      this._formFieldsService.getFormFieldAvailableValues(formField.FieldType).then((data) => {
        this.availableValues = data;
      });
    }
  };

  public onSelectedFormFieldValueChange = (availableValue: any): void => {
    this.selectedFormField.FieldValue = availableValue.Value;
    this.selectedLabelText = availableValue.Name.toString();
    this.selectedFieldPrice = null;
    this.potentialFieldPrice = null;
    this.hasArc = false;
    this.useArc = false;
    this.availableArcs = [];
    this.selectedArc = new ArcFormula();
    // setup placeholder price. only by entering text do they actually set, and override the price, otherwise it gets set when the template is pulled by the public form.
    if (/*this.formSettings.FormType == FormTypeEnum.JoinForm &&*/ this.selectedFormField.FieldType == 85) {
      this._revenueItemService.getRevenueItem(this.selectedFormField.FieldValue).then((data) => {
        let price = data.UnitPrice;
        if (price <= 0) {
          price = data.BasePrice;
        }
        this.potentialFieldPrice = price;
      });

      this._arcService
      .searchArcs(<ArcSearch>{ ItemNum: this.selectedFormField.FieldValue, Inactive: false, PageNumber: 0, PageSize: 0 })
      .then((data) => {
        if (data.TotalCount) {
          this.hasArc = true;
          this.availableArcs = data.Result;
          if (data.TotalCount == 1) {
            this.selectedArc = data.Result[0];
          }
        }
      });
    }
  };

  public onEditChanges = (data: any): void => {
    this.updateFormElementOrder();
  };

  public updateFormElementOrder = (): void => {
    var sortStart = 1;

    for (var group of this.formTemplate.FormGroups) {
      group.GroupElements = group.GroupElements.sort((n1: FormElement, n2: FormElement) => {
        return n1.Order - n2.Order;
      });

      //after the sort reset all the order numbers so they start at 1
      for (var element of group.GroupElements) {
        element.Order = sortStart;
        sortStart = sortStart + 1;
      }

      //call sort again to force the UI to update with the renumbering starting from 1
      group.GroupElements = group.GroupElements.sort((n1: FormElement, n2: FormElement) => {
        return n1.Order - n2.Order;
      });
    }
  };

  public moveUp = (formGroup: FormGroup, formElement: FormElement): void => {
    var proposedOrder = formElement.Order - 1;

    for (var element of formGroup.GroupElements) {
      if (element.Order >= proposedOrder) {
        element.Order = element.Order + 1;
      }
    }

    formElement.Order = proposedOrder;
    this.updateFormElementOrder();
  };

  public moveDown = (formGroup: FormGroup, formElement: FormElement): void => {
    var proposedOrder = formElement.Order + 1;

    for (var element of formGroup.GroupElements) {
      if (element.Order <= proposedOrder) {
        element.Order = element.Order - 1;
      }
    }

    formElement.Order = proposedOrder;

    this.updateFormElementOrder();
  };

  public resetNewFormElementModal = (): void => {
    this.fieldIsRequired = false;
    this.useArc = false;
    this.hasArc = false;
    if (this.availableFormWidgetTypes && this.availableFormWidgetTypes.length) {
      this.selectedWidgetType = this.availableFormWidgetTypes[0];
    }
    if (this.availableFormFieldGroups && this.availableFormFieldGroups.length) {
      this.selectedFormFieldGroup = this.availableFormFieldGroups[0];
    }

    this.selectedFormField = new FormField();
  };

  public openNewFormElementWidgets = (): void => {
    this.resetNewFormElementModal();
    this.showNewItemModal = true;
    //this.showNewFormElementWidgets = true;
  };

  public openNewFormElementWidgetForIndex = (i: number): void => {
    this.resetNewFormElementModal();
    this._formElementIndex = i;
    this.showNewItemModal = true;
  };

  public cancelNewFormElementWidgets = (): void => {
    this._formElementIndex = -1;
    this.showNewItemModal = false;
    //this.showNewFormElementWidgets = false;
  };

  public openEditSettingsWidget = (): void => {
    this._utilService.map(this.formTemplate.FormSettings, this.formSettings);
    this._formSettingsComponent.validationError = '';
    this.showSettingsModal = true;
  };

  public saveSettings = (): void => {
    if (this._formSettingsComponent.isValid()) {
      this.formTemplate.FormSettings = new FormBuilderSettings();
      this._utilService.map(this.formSettings, this.formTemplate.FormSettings);
      this.showSettingsModal = false;

      var membershipChanged: boolean = false;

      let elementsTEMP = new Array<any>();

      if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Individual) {
        for (var element of this.formTemplate.FormGroups[0].GroupElements) {
          switch (element.Field.FieldName) {
            case 'Profile_OrgName':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_FirstName':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_LastName':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_Mi':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_Prefix':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_Suffix':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_Title':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            default:
              break;
          }
        }
      } else if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
        for (var element of this.formTemplate.FormGroups[0].GroupElements) {
          switch (element.Field.FieldName) {
            case 'Profile_FirstName':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'Profile_LastName':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'Profile_Mi':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'Profile_Prefix':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'Profile_Suffix':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'Profile_Title':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            case 'RelatedProfile_MainContact_Contact_OrgName':
              elementsTEMP.unshift(element);
              membershipChanged = true;
              break;
            default:
              break;
          }
        }
      }

      for (element of elementsTEMP) {
        this.removeFormElement(element, this.formTemplate.FormGroups[0]);
      }

      if (membershipChanged == true) {
        this.resetFormFieldGroups();
      }
    }
  };

  private resetFormFieldGroups = (): void => {
    this._formFieldsService.getFormFieldsForGroup(this.selectedFormFieldGroup.FieldGroupType).then((data: any) => {
      var tempAvailableFormFields: Array<FormField> = data;

      //remove either profile org name field or first/last/mi name fields if form setting is for org or ind
      if (this.selectedFormFieldGroup.FieldGroupType == 1) {
        for (let tempFormFields of this.availableFormFieldsRAW) {
          if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
            if (tempFormFields.FieldName == 'Profile_OrgName') {
              this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
              this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 1);
            }
          } else {
            switch (tempFormFields.FieldName) {
              case 'Profile_FirstName':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 1);
                break;
              case 'Profile_LastName':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 2);
                break;
              case 'Profile_Mi':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 3);
                break;
              case 'Profile_Prefix':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 4);
                break;
              case 'Profile_Suffix':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 5);
                break;
              case 'Profile_Title':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 6);
                break;
              default:
                break;
            }
          }
        }

        if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_FirstName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_LastName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Mi');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Prefix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Suffix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_Title');
        } else {
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'Profile_OrgName');
        }
      }

      //do opposite of above for main contact
      if (this.selectedFormFieldGroup.FieldGroupType == 6) {
        for (let tempFormFields of this.availableFormFieldsRAW) {
          if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
            switch (tempFormFields.FieldName) {
              case 'RelatedProfile_MainContact_FirstName':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 1);
                break;
              case 'RelatedProfile_MainContact_LastName':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 2);
                break;
              case 'RelatedProfile_MainContact_Mi':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 3);
                break;
              case 'RelatedProfile_MainContact_Prefix':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 4);
                break;
              case 'RelatedProfile_MainContact_Suffix':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 5);
                break;
              case 'RelatedProfile_MainContact_Title':
                this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
                this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 6);
                break;
              default:
                break;
            }
          } else {
            if (tempFormFields.FieldName == 'RelatedProfile_MainContact_Contact_OrgName') {
              this._utilService.arrayAddEntryToBeginning(this.availableFormFields, tempFormFields);
              this._utilService.arrayMoveItemToIndex(this.availableFormFields, 0, 1);
            }
          }
        }

        if (this.formTemplate.FormSettings.FormOrgIndEnum == ProfileOrgIndEnum.Organization) {
          this._utilService.arrayRemoveEntryByPropertyValue(
            this.availableFormFields,
            'FieldName',
            'RelatedProfile_MainContact_Contact_OrgName'
          );
        } else {
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_FirstName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_LastName');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Mi');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Prefix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Suffix');
          this._utilService.arrayRemoveEntryByPropertyValue(this.availableFormFields, 'FieldName', 'RelatedProfile_MainContact_Title');
        }
      }
    });
  };

  public cancelEditSettings = (): void => {
    this.showSettingsModal = false;
    this.formSettings = new FormBuilderSettings();
  };

  public getNextFormElementOrderNumber = (): number => {
    let order: number = this.formTemplate.FormGroups[0].GroupElements.length + 1;
    return order;
  };

  public canSelectField = (fieldGroupType: number): boolean => {
    // reusing canEditLabelText since these features overlap at this time.
    return this.canEditLabelText(fieldGroupType);
  };

  public canEditLabelText = (fieldGroupType: number): boolean => {
    return [
      FieldGroupTypeEnum.ProfileFields,
      FieldGroupTypeEnum.PurchaseItemFields,
      FieldGroupTypeEnum.AdditionalInfoFields,
      FieldGroupTypeEnum.MainContactFields,
      FieldGroupTypeEnum.CustomField,
    ].some((x) => x == fieldGroupType);
  };

  public canBeRequired = (fieldGroupType: number): boolean => {
    return [
      ValueTypeEnum.string,
      ValueTypeEnum.int,
      ValueTypeEnum.decimal,
      ValueTypeEnum.date,
      ValueTypeEnum.boolean,
      ValueTypeEnum.StringDropDown,
      ValueTypeEnum.State,
      ValueTypeEnum.AffiliationChecklist,
    ].some((x) => x == fieldGroupType);
  };

  public updateFormElementAvailableMutualExclusiveControlOptions = (): void => {
    var availFormElements = new Array<FormElementSummary>();
    for (let el of this.formTemplate.FormGroups[0].GroupElements) {
      if (this._utilService.isNotNullOrUndefined(el.Field)) {
        if (el.Field.DisplayValueType == 5) {
          var item = new FormElementSummary(el.LabelText, el.Guid, false);
          availFormElements.push(item);
        }
      }
    }
    let i: number = 0;
    for (let el of this.formTemplate.FormGroups[0].GroupElements) {
      if (this._utilService.isNotNullOrUndefined(el.Field)) {
        if (el.Field.DisplayValueType == 5) {
          var meElementsToSet = new Array<FormElementSummary>();
          for (let me of availFormElements) {
            var isExistingSelectedElement = false;
            for (let e of el['MutuallyExclusiveFormElements']) {
              if (e.Guid == me.Guid) {
                if (e.Selected == true) {
                  isExistingSelectedElement = true;
                }
              }
            }

            if (me.Guid != el.Guid) {
              var item = new FormElementSummary(me.Name, me.Guid, false);
              if (isExistingSelectedElement == true) {
                item.Selected = true;
              } else {
                item.Selected = false;
              }
              meElementsToSet.push(item);
            }
          }

          el['MutuallyExclusiveFormElements'] = meElementsToSet;
        }
      }

      i = i + 1;
    }
  };
}
